import React from "react";
import { CheckIcon } from "lucide-react";
import { commitments } from "../data/commitments";
export function Management() {
  return <section id="professionnels" className="w-full bg-ink py-24 text-white lg:py-32" data-id="element-119" data-mp="3p6fhjj291sru">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-120" data-mp="3ber5tgvwx6be">
        <div className="lg:col-span-5" data-id="element-121" data-mp="3gdlkq7qreaq8">
          <h2 className="font-serif text-4xl font-medium leading-tight lg:text-5xl" data-id="element-122" data-mp="3gcivs5czyicy">
            La gestion de vos placements par Success Capital
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/70" data-id="element-123" data-mp="36hiil1vwqc3a">
            Nos experts vous accompagnent selon votre profil de risque et vos objectifs. Votre épargne est
            régulièrement réorientée en fonction des opportunités et des évolutions de marchés.
          </p>
        </div>
        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-6 lg:col-start-7" data-id="element-124" data-mp="qqcwb84az0bx">
          {commitments.map(c => <li key={c.title} className="flex gap-5 py-6" data-id="element-125" data-mp="vmblgxxggmde">
              <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-126" data-mp="11gcs3fmoeyru">
                <CheckIcon className="h-3.5 w-3.5" data-id="element-127" data-mp="xfkhahy5oltg" />
              </span>
              <div data-id="element-128" data-mp="1b7qmj8zrt8e4">
                <h3 className="text-lg font-medium" data-id="element-129" data-mp="1b65txox0nziw">{c.title}</h3>
                <p className="mt-1 text-white/60" data-id="element-130" data-mp="167vwt8rqeoun">{c.text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}